
















import { PartSearchResultDetails } from '@/entities/PartSearchResultDetails';
import { localize } from '@/filters/localize';
import BaseMixin from '@/mixins/BaseMixin';
import { PartSearchService } from '@/services/part-search-service';
import { PartSearchModuleTypes } from '@/store/modules/part-search';
import Vue from 'vue';
import { Component, Mixins, Prop, Watch } from 'vue-property-decorator';
import SearchablePartsList from '../part-search/SearchablePartsList.vue';

@Component({
    components: {
        SearchablePartsList,
    },
})
export default class BrandPartsSearchBox extends Mixins(BaseMixin) {
    private readonly partSearchService: PartSearchService = new PartSearchService();

    @Prop()
    private brand!: string;

    @Prop()
    private partActionLink!: string;

    private searchTerm: string = '';
    private parts: PartSearchResultDetails[] = [];
    private hasAdditionalParts: boolean = false;
    private totalNumberOfParts: number = 0;

    public mounted(): void {
        this.searchTerm = '*';
    }

    private get title(): string {
        const format = localize(this.l10n.PART_SEARCH.SEARCH_BOX_TITLE);

        if (format) {
            return format.replace('{0}', this.brand);
        }

        return this.brand;
    }

    private get numberOfParts(): number {
        return this.$store.getters[PartSearchModuleTypes.getters.numberOfResultsPerPageForSearch];
    }

    @Watch('searchTerm')
    private updateParts(): void {
        this.partSearchService
            .getSearchResultsShuffled(this.searchTerm, this.brand, '', 12)
            .then((result) => {
                this.parts = result.partSearchResultDetails;
                this.hasAdditionalParts = result.totalNumberOfResults > this.numberOfParts;
                this.totalNumberOfParts = result.totalNumberOfResults;
            });
    }

    private get linkToAdditionalParts(): string {
        return this.partSearchService.getUrlForPartSearchPage(this.searchTerm, this.brand, 1, '');
    }

    private onSearchTermChanged(newTerm: string): void {
        if (newTerm === '') {
            newTerm = '*';
        }

        this.searchTerm = newTerm;
    }
}
